import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [];

  return (
    <section style={styles.section}>
      <div className="container" style={styles.container}>
        {/* Section Header */}
        <div style={styles.header}>
          <span style={styles.subtitle}>Got Questions?</span>
          <h2 style={styles.title}>
            Frequently <span style={styles.accent}>Asked</span> Questions
          </h2>
          <p style={styles.description}>
            Find answers to common questions about partnering with Panmitra
            Online Service Pvt. Ltd. .
          </p>
        </div>

        {/* FAQ Accordion */}
        <div style={styles.faqWrapper}>
          {faqs.map((faq, index) => (
            <div key={index} style={styles.faqItem}>
              <div style={styles.question} onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                <span style={styles.icon}>
                  {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
              {openIndex === index && (
                <div style={styles.answer}>
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Inline styles – you can move these to a CSS file
const styles = {
  section: {
    backgroundColor: "#f9fafc",
    padding: "80px 0",
    fontFamily: "'Inter', sans-serif",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "0 20px",
  },
  header: {
    textAlign: "center",
    marginBottom: "60px",
  },
  subtitle: {
    display: "inline-block",
    backgroundColor: "#f39c1220",
    color: "#f39c12",
    fontWeight: "600",
    fontSize: "0.9rem",
    padding: "4px 16px",
    borderRadius: "30px",
    marginBottom: "16px",
  },
  title: {
    fontSize: "clamp(2rem, 4vw, 2.8rem)",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "16px",
    lineHeight: "1.2",
  },
  accent: {
    color: "#f39c12",
  },
  description: {
    fontSize: "1.1rem",
    color: "#64748b",
    maxWidth: "600px",
    margin: "0 auto",
  },
  faqWrapper: {
    marginBottom: "40px",
  },
  faqItem: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    marginBottom: "16px",
    padding: "0",
    boxShadow: "0 5px 15px rgba(0,0,0,0.02)",
    border: "1px solid #eef2f6",
    overflow: "hidden",
  },
  question: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 25px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#1e293b",
    fontSize: "1.1rem",
    transition: "background-color 0.2s ease",
    backgroundColor: "#ffffff",
  },
  icon: {
    color: "#f39c12",
    fontSize: "0.9rem",
  },
  answer: {
    padding: "0 25px 20px 25px",
    color: "#64748b",
    lineHeight: "1.6",
    borderTop: "1px solid #eef2f6",
    backgroundColor: "#f9fafc",
  },
  loadMore: {
    textAlign: "center",
  },
  loadMoreLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    color: "#f39c12",
    fontWeight: "500",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "gap 0.2s ease",
  },
  arrowIcon: {
    fontSize: "0.8rem",
  },
};

// Hover effects (can be added via CSS):
/*
  .faq-question:hover {
    background-color: #f9fafc;
  }
  .faq-load-more:hover {
    gap: 12px;
  }
*/

export default Faq;
